<template>
	<div class="infinite-images-container">
		<div>
			<div class="infinite-images entry-media-container" v-for="(image, index) in images" :key="image.id">
				<media-image 
					:image="image" 
					:entry="entry" 
					:options="{ lazy : true}" 
					:index="index+1"
					:show-comments="false"
					:show-up-vote="true">
				</media-image>
			</div>
		</div>
		<loading-indicator v-show="loading"></loading-indicator>
		<div class="uk-margin uk-text-center" v-show="!loading" ref="observer">
			<button class="uk-button uk-button-primary uk-width-1-1" @click="loadImages">Meer meer meer!</button>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import LoadingIndicator from './LoadingIndicator.vue'
import MediaImage from './MediaImage.vue'
	
export default {
	components: {
		LoadingIndicator,
		MediaImage
	},
	props: {
		criteria: Object,
		maxWidth: {
			type: String,
			default: "600px",
		},
	},
	data() {
		return {
			page: 1,
			url: "/api/media",
			images: [],
			entry: [],
			loading: true,
			elementObserver: null
		};
	},
	mounted() {
		
		// Initial load
		this.loadImages();
	
		// Add observer
		const elementToObserve = this.$refs.observer;
	
		// Create observer for lazy elements
		this.elementObserver = new IntersectionObserver((entries, elObserver) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting && !this.loading) {
					this.$logger('app/components/infinitePicdump/observable element detected');
					this.page++;
					this.loading = true;
					this.loadImages();
				}
			});
		});
	
		this.elementObserver.observe(elementToObserve);
	},
	beforeDestroy() {
		this.removeElementObserver();
	},		
	methods: {
		loadImages() {
			const url = this.url;
			const criteria = this.criteria;
	
			this.$logger('app/components/infinitePicdump/loadImages, url: ' + this.url + ', page: ' + this.page);
	
			this.loading = true;
	
			axios.get(url, {
				params: {
					categoryId: criteria.categoryId,
					page: this.page,
				},
			})
			.then((response) => {
				const data = response.data;
	
				this.loading = false;

				if (!data || !data.items || data.items.length === 0) {
					// No data received, remove the elementObserver and stop loading
					this.removeElementObserver();
					return;
				}
				
				const images = data.items[0].images;
				const entry = data.items[0].entry;
				const currentImages = this.images;
				const newImages = currentImages.concat(images);
	
				// Update component data
				this.images = newImages;
				this.entry = entry;
	
				this.page++;
				this.loading = false;
			})
			.catch((error) => {
				// Handle Axios error, remove the elementObserver, and stop loading
				this.$logger('app/components/infinitePicdump/Axios error: ' + error.message);
				this.removeElementObserver();
				this.loading = false;
			});			
		},
		removeElementObserver() {
			if (this.elementObserver) {
				this.elementObserver.disconnect();
				this.elementObserver = null;
			}
		},
	},
};
</script>

<style scoped>
/* Add scoped CSS styles if necessary */
</style>
